module.exports = {
    key: 'key',
}